import constants from "../../core/constants";
import moment from "moment";
import { parsePrice } from "../../core/utils";
import { map, isNil } from "lodash/fp";

class InvoiceItemsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { name: "captain", title: "Captain" },
      { name: "type", title: "Type" },
      { name: "invoice", title: "Invoice id" },
      { name: "ride", title: "Ride id" },
      { name: "active", title: "Active" },
      { name: "amount", title: "Amount" },
      { name: "createdAt", title: "created At" },
    ];

    this.filters = [
      {
        name: "captain",
        title: "Captain",
        icon: "person",
        resource: "Captain",
        size: 25,
      },
      { name: "active", title: "Active", icon: "person", list: "active" },
      { name: "city", title: "City", icon: "location_city", resource: "City" },
      { name: "date", title: "Select date", icon: "date_range", isDate: true },
      {
        name: "cash_collection_status",
        title: "Cash Collection Status",
        icon: "monetization_on",
        list: "cashCollectionStatus",
        multiple: true,
      },
    ];
  }

  justify(data) {
    const format = (item) => {
      if (!isNil(item) && !isNil(item.invoice)) {
        item.createdAt = moment(item.createdAt).format(constants.dateFormat);
        item.amount = parsePrice(item.amount);
        item.invoice = item.invoice._id;
        item.type = item.type.name;
      }
      return item;
    };

    return map(format)(data);
  }

  justifyTypes(data) {
    const format = (item) => ({ title: item.name, name: item.key });

    return map(format)(data);
  }
}

export default InvoiceItemsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/invoiceItems/invoiceItems.transforms.js